import React, { useEffect,useState } from "react";
import Box from "@mui/material/Box";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
// import Button from "@mui/material/Button";
import useMediaQuery from "@mui/material/useMediaQuery";
import { useTheme } from "@mui/material/styles";
import passiveImg from "@/_images/ISA_Wide1.png";
import activeImg from "@/_images/ISA_Wide2.png";
import RemoveCircleIcon from "@mui/icons-material/RemoveCircle";
import CheckBoxIcon from "@mui/icons-material/CheckBox";
import PropTypes from "prop-types";
// import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import { useTranslation } from "react-i18next";
import ContinueButton from "./ContinueButton";

const WhyIsa = ({
  experienceType,
  submitting,
  setActiveStep,
  handleUpdate,
}) => {
  const { t, i18n } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const [data, setData] = useState(null);
  const [experiencedDriver, setExperiencedDriver] = useState(false);

  const handleClickEnrollNow = () => {
    setActiveStep((prev) => prev + 1);
    handleUpdate("WhyIsa");
  };

  const content = {
    inexperienced: {
      title: t("speed.buildSafeTitle"),
      subtitle: t("speed.buildSafeSubtitle"),
      passiveTitle: t("speed.passiveTitle"),
      activeTitle: t("speed.activeTitle"),
      passivePoints: [
        t("speed.passivePoint1"),
        t("speed.passivePoint2"),
        t("speed.passivePoint3"),
      ],
      activePoints: [t("speed.activePoint1"), t("speed.activePoint2")],
      paragraph1: t("speed.paragraphInexperienced1"),
      paragraph2: t("speed.paragraphInexperienced2"),
    },
    experienced: {
      title: t("speed.reinforceSafeTitle"),
      subtitle: t("speed.reinforceSafeSubtitle"),
      passiveTitle: t("speed.passiveTitle"),
      activeTitle: t("speed.activeTitle"),
      passivePoints: [
        t("speed.passivePoint1"),
        t("speed.passivePoint2"),
        t("speed.passivePoint3"),
      ],
      activePoints: [t("speed.activePoint1"), t("speed.activePoint2")],
      paragraph1: t("speed.paragraphExperienced1"),
      paragraph2: t("speed.paragraphExperienced2"),
    },
  };

  useEffect(() => {
  if (!Array.isArray(experienceType)) return;

  const driverExp = experienceType.find((item) => item.questionCode === "DRIVEREXP")?.response;

  // const whyIsa = experienceType.find((item) => item.questionCode === "WHYISA")?.response;

  if (
    driverExp === "0-3 months" ||
    driverExp === "3-6 months"
  ) {
    setData(content["inexperienced"]);
    setExperiencedDriver(false);
  } else if (
    driverExp === "6-12 months" ||
    driverExp === "1+ year"
  ) {
    setData(content["experienced"]);
    setExperiencedDriver(true);
  } else {
    setData(content["inexperienced"]);
    setExperiencedDriver(false);
  }
}, [experienceType,i18n.language]);


  const boldWords = [
    "passive speed limiting",
    "active speed limiting",
    "safest, most consistent",
    "highest risk",
    "but so can risky behavior",
  ];

  const highlightText = (text, highlights) => {
    if (!text || !highlights || highlights.length === 0) return text;
    const parts = text.split(new RegExp(`(${highlights.join("|")})`, "gi"));
    return parts.map((part, i) =>
      highlights.some((word) => word === part) ? (
        <Box
          key={i}
          component="span"
          sx={{
            fontWeight: 700,
            fontStyle:
              part === "but so can risky behavior" || part === "highest risk"
                ? "italic"
                : "normal",
          }}
        >
          {part}
        </Box>
      ) : (
        part
      )
    );
  };

  return (
    <Box
      sx={{
        width: "100%",
        mt: "25px",
        backgroundColor: "#fff",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        px: isMobile ? 2 : 0.5,
      }}
    >
      <Grid
        container
        spacing={isMobile ? 2 : 2}
        sx={{
          maxWidth: isMobile ? "100%" : 750,
        }}
      >
        <Grid size={12}>
          <Typography
            variant="body1"
            sx={{
              color: "#1A1A1A",
              textAlign: "left",
              // maxWidth: 700,
            }}
          >
            {highlightText(data?.subtitle, boldWords)}
          </Typography>

          {experiencedDriver && (
            <Typography
              sx={{
                fontWeight: 700,
                fontSize: "22px",
                color: "#1A1A1A",
                textAlign: "left",
                lineHeight: 1,
                mt: 3,
              }}
            >
              {t("speed.howIsa")}
            </Typography>
          )}
        </Grid>

        <Grid size={{ xs: 6, sm: 6 }}>
          <Box sx={{ textAlign: "center" }}>
            <Box
              component="img"
              src={passiveImg}
              alt="Passive Limiting"
              sx={{
                width: "100%",
                borderRadius: 1,
                maxHeight: isMobile ? 150 : 180,
                objectFit: "cover",
              }}
            />
            <Typography
              variant="subtitle1"
              sx={{
                fontWeight: 600,
                display: "flex",
                justifyContent: "left",
                alignItems: "left",
                textAlign: "left",
              }}
            >
              <span style={{ marginRight: 4 }}>
                <RemoveCircleIcon style={{ color: "#d1495b" }} />
              </span>
              {data?.passiveTitle}
            </Typography>

            {data?.passivePoints.map((point, i) => (
              <Typography
                key={i}
                variant="body2"
                sx={{
                  color: "#333",
                  lineHeight: 1.6,
                  textAlign: "left",
                  display: "flex",
                  alignItems: "start",
                }}
              >
                <span style={{ marginRight: 4 }}>•</span>
                <span>{point}</span>
              </Typography>
            ))}
          </Box>
        </Grid>

        <Grid size={{ xs: 6, sm: 6 }}>
          <Box sx={{ textAlign: "center" }}>
            <Box
              component="img"
              src={activeImg}
              alt="Active Limiting"
              sx={{
                width: "100%",
                borderRadius: 1,
                maxHeight: isMobile ? 150 : 180,
                objectFit: "cover",
              }}
            />
            <Typography
              variant="subtitle1"
              sx={{
                fontWeight: 600,
                display: "flex",
                justifyContent: "left",
                alignItems: "left",
                textAlign: "left",
              }}
            >
              <span style={{ marginRight: 4 }}>
                <CheckBoxIcon style={{ color: "#76bc21" }} />
              </span>
              {data?.activeTitle}
            </Typography>

            {data?.activePoints.map((point, i) => (
              <Typography
                key={i}
                variant="body2"
                sx={{
                  color: "#333",
                  lineHeight: 1.6,
                  textAlign: "left",
                  display: "flex",
                  alignItems: "start",
                }}
              >
                <span style={{ marginRight: 4 }}>•</span>
                <span>{point}</span>
              </Typography>
            ))}
          </Box>
        </Grid>
      </Grid>

      <Grid size={12} sx={{ mb:"25px" }}>
        <Typography
          variant="body1"
          sx={{
            mt: isMobile ? 3 : 5,
            maxWidth: 750,
            textAlign: "left",
            color: "#333",
            lineHeight: 1.7,
          }}
        >
          {highlightText(data?.paragraph1, boldWords)}
        </Typography>
        <Typography
          variant="body1"
          sx={{
            mt: 2,
            maxWidth: 750,
            textAlign: "left",
            color: "#333",
            lineHeight: 1.7,
          }}
        >
          {highlightText(data?.paragraph2, boldWords)}
        </Typography>
      </Grid>

      {/* <Button
        variant="contained"
        size="medium"
        style={{
          backgroundColor: "#76bc21",
          color: "#000",
          fontWeight: "bold",
          marginTop: isMobile ? 16 : 16,
          width: isMobile ? "100%" : 300,
        }}
        endIcon={
          <span style={{ display: "flex", fontWeight: "bold" }}>
            <ArrowForwardIcon />
          </span>
        }
      >
        {t("speed.enrollNow")}
      </Button> */}

      <ContinueButton
        submitting={submitting}
        onClick={() => handleClickEnrollNow()}
        continueText={t("speed.enrollNow")}
        isLongWidth={true}
        isFullWidth={true}
      />
    </Box>
  );
};

WhyIsa.propTypes = {
  experienceType: PropTypes.string,
  setActiveStep: PropTypes.func,
  submitting: PropTypes.bool,
  handleUpdate: PropTypes.func,
};

export default WhyIsa;
